module.exports = __webpack_public_path__ + "static/media/party.8b362c86.svg";